/**
 * Shoelace is a utility library for web components like icons, dialogs, buttons, etc.
 * https://shoelace.style/
 */

import { setBasePath } from "@shoelace-style/shoelace/dist/utilities/base-path.js";
import { registerIconLibrary } from "@shoelace-style/shoelace/dist/utilities/icon-library.js";
import { dependencies } from "../../package.json";

const CDN_BASE = "https://sdk.beamimpact.com";
const SHOELACE_BASE = `${CDN_BASE}/lib/shoelace/v${dependencies["@shoelace-style/shoelace"]}`;
const ICON_BASE = `${CDN_BASE}/lib/lucide-static/v${dependencies["lucide-static"]}`;

registerIconLibrary("lucide", {
  resolver: (name: string) => `${ICON_BASE}/icons/${name}.svg`,
});

setBasePath(SHOELACE_BASE);

if (document && !document.querySelector("link[data-beam-impact]")) {
  const stylesheet = document.createElement("link");
  stylesheet.href = `${SHOELACE_BASE}/themes/light.css`;
  stylesheet.rel = "stylesheet";
  stylesheet.setAttribute("data-beam-impact", "true");
  document.head.appendChild(stylesheet);
}
